import { cva } from 'class-variance-authority';
import './hero-banner.scss';

export const heroBannerVariants = cva('hero-banner', {
    variants: {
        variant: {
            default: 'hero-banner--default',
            offset: 'hero-banner--offset',
            fullscreen: 'hero-banner--fullscreen',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
